


















import {defineComponent, ref, watch} from "@vue/composition-api";
import {useGetters, useMutations} from "vuex-composition-helpers";

export default defineComponent({
  name: "Form",
  methods: {
    /* Disable search on ENTER */
    sendSearch(e: Event): void {
      e.preventDefault();
    },
    onChange(): void {
      this.$store.commit('setSearchQuery', this.query);
    }
  },
  setup: () => {
    const {searchQuery, labels} = useGetters(["searchQuery", "labels"])
    const {setSearchQuery} = useMutations(['setSearchQuery'])
    const query = ref('');

    watch(query, (value) => {
      setSearchQuery(value);
    })

    return {searchQuery, labels, query, setSearchQuery}
  }
})
